// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KDV9","footer":"styles_footer__lq9JY","passCodeTooltip":"styles_passCodeTooltip__JSW9W"};